module.exports = __webpack_public_path__ + "media/images/top/MV-eb0b07930ab6738cf3d3612ac611cc52.jpg";